module.exports = __webpack_public_path__ + "img/noaa-logo.a59b95e3.png";